export interface BadUploadToggle {
  uploadTag: string;
  flagged: boolean;
}

export const exampleBadUploadToggle: BadUploadToggle = {
  uploadTag: 'Marketing Milk (BID 1) - 07-01-2020-07-09-2020-Purchases - 1',
  flagged: true,
};
